import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getListSocial = (params, headers) => request.get('/api/v1/socials', { params, ...headers });
export const createSocial = data => request.post('/api/v1/socials', data);
export const updateSocial = data => request.post('/api/v1/socials/update', data);
export const updateSocialStatus = data => request.post('/api/v1/socials/update-status', data);
export const deleteSocial = data => request.post('/api/v1/socials/delete', data);
// Mutation
export const useCreateSocialMutation = () => useMutation({ mutationFn: createSocial });
export const useUpdateElementSocialMutation = () => useMutation({ mutationFn: updateSocial });
export const useGetSocialListMutation = () => useMutation({ mutationFn: getListSocial });
export const useDelSocialListMutation = () => useMutation({ mutationFn: deleteSocial });
export const useUpdateSocialMutation = () => useMutation({ mutationFn: updateSocialStatus });
// Query
export const useQueryGetSocialList = (params, options = {}) =>
  useQuery({ queryKey: ['getSocialList', params], queryFn: () => getListSocial(params), ...options });
